<template>
  <div
    class="modal fade"
    :ref="`modal-product-detail`"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{
              $t(
                productGroupData.id === 0
                  ? "product.productGroupList.addProductGroup"
                  : "product.productGroupList.productGroupDetail"
              )
            }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("product.productGroupList.productGroupName")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="productGroupData.productGroupName"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{ $t("apartmentGroup.description") }}</label>
                <textarea
                  class="form-control"
                  name=""
                  id=""
                  cols="30"
                  rows="4"
                  v-model="productGroupData.description"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/lib/utils";
// import Enum from "../../../enum/enum";
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    apartmentId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data: () => ({
    productGroupData: {
      id: 0,
      productGroupName: null,
      description: null
    }
  }),
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    onShowAddNew: function(apartmentImgType) {
      $(this.$refs[`modal-product-detail`]).modal("show");
      this.productGroupData = {
        id: 0,
        productGroupName: null,
        description: null
      };
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-product-detail`]).modal("show");
      this.productGroupData = {
        id: data.id,
        productGroupName: data.productGroupName,
        description: data.description
      };
    },
    onCloseModal: function() {
      $(this.$refs[`modal-product-detail`]).modal("hide");
    },
    onSave: async function() {
      if (utils.isEmptyString(this.productGroupData.productGroupName)) {
        this.showError(this.$t("product.productGroupList.productGroupName"));
      } else {
        let data = {
          id: this.productGroupData.id,
          name: this.productGroupData.productGroupName,
          description: this.productGroupData.description
        };
        if (this.productGroupData.id === 0) {
          this.CREATE_PRODUCT_GROUP(data)
            .then(
              function() {
                this.onCloseModal()
                this.$emit('callbackGetProductGroup')
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_PRODUCT_GROUP(data)
            .then(
              function() {
                this.onCloseModal()
                this.$emit('callbackGetProductGroup')
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      }
    },
    showError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "CREATE_PRODUCT_GROUP",
      "UPDATE_PRODUCT_GROUP"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Product/ProductGroupDetail.vue